import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-spinner',
    template: `<div class="d-flex justify-content-center align-items-center" style="height: 60vh;">
    <div class="spinner-border text-danger" role="status"></div>
    &nbsp;&nbsp;
    <span class="text-dark">Récupération des données en cours...</span>
</div>
`})

export class SpinnerComponent {
    @Input() analyse: any;
    @Output() SoumettreMasse = new EventEmitter<number>();
    @Output() exportGlobal = new EventEmitter<number>();
}